package com.tovtalk.domain.entity

data class FeedPage(
    val posts: List<Post>,
    val nextCursor: String? = null,
    val kashrutRestricted: Boolean = false
) {
    val hasMore: Boolean get() = nextCursor != null
}
